import { render, staticRenderFns } from "./ArchiveIcon.vue?vue&type=template&id=67b07f42&scoped=true"
import script from "./ArchiveIcon.vue?vue&type=script&lang=js"
export * from "./ArchiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b07f42",
  null
  
)

export default component.exports